export const roles = [
    'SystemAdministrator',
    // 'FacilityUser',
    'Nurse',
    'LabUser',
    'CHO',
    'Receptionist',
    'Doctor',
    'SuperAdmin',
    'PharmacyUser',
    'InsuranceUser',
];

export const pobs = [
    { label: 'Bo', value: 'Bo' },
    { label: 'Bombali', value: 'Bombali' },
    { label: 'Bonthe', value: 'Bonthe' },
    { label: 'Falaba', value: 'Falaba' },
    { label: 'Kailahun', value: 'Kailahun' },
    { label: 'Kambia', value: 'Kambia' },
    { label: 'Karene', value: 'Karene' },
    { label: 'Kenema', value: 'Kenema' },
    { label: 'Koinadugu', value: 'Koinadugu' },
    { label: 'Kono', value: 'Kono' },
    { label: 'Moyamba', value: 'Moyamba' },
    { label: 'Port Loko', value: 'Port Loko' },
    { label: 'Pujehun', value: 'Pujehun' },
    { label: 'Tonkolili', value: 'Tonkolili' },
    { label: 'W. Urban', value: 'W. Urban' },
    { label: 'W. Rural', value: 'W. Rural' },
];

export const patientCategories = [
    { label: 'Infant (<5yrs)', value: 'Infant (<5yrs)' },
    { label: 'Child (6-18yrs)', value: 'Child (6-18yrs)' },
    { label: 'Adult (18-65yrs)', value: 'Adult (18-65yrs)' },
    { label: 'Aged (>65yrs)', value: 'Aged (>65yrs)' },
];

/** Mother / father full name required in patient registration when category is Infant or Child */
export const patientCategoriesRequiringParentDetails = new Set([
    'Infant (<5yrs)',
    'Child (6-18yrs)',
]);

export const patientIdentityOptions = [
    { label: 'National', value: 'National' },
    { label: 'International', value: 'International' },
];

export const labOrderResultUsers = [
    'LabUser',
    'SuperAdmin',
    'SystemAdministrator',
    'FacilityUser',
];

export const userRoles = [
    'SystemAdministrator',
    'Nurse',
    'LabUser',
    'CHO',
    'Receptionist',
    'Doctor',
    'PharmacyUser',
    'InsuranceUser',
];
export const userRolesSystemAdmin = [
    'Nurse',
    'LabUser',
    'CHO',
    'Receptionist',
    'Doctor',
    'PharmacyUser',
    'InsuranceUser',
];

export const initialUserValues = {
    firstName: '',
    lastName: '',
    gender: '',
    email: '',
    address: '',
    mobileCodeId: 0,
    mobileNumber: '',
    eSigned: 'NA',
    isBlocked: false,
    roleName: '',
    isDelete: false,
};

export const initialFacilityValues = {
    name: '',
    address: '',
    district: '',
    email: '',
    category: '',
    noOfStaff_Male: 0,
    noOfStaff_Female: 0,
    eSigned: 'NA',
    mobileCodeId: 0,
    mobileNumber: '',
    roleName: 'FacilityUser',
};

export const userTableCols = [
    { id: 'firstName', label: 'First name' },
    { id: 'lastName', label: 'Last name' },
    { id: 'gender', label: 'Gender' },
    { id: 'email', label: 'Email' },
    { id: 'roleName', label: 'Role' },
    { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const unitsTableCols = [
    { id: 'unitName', label: 'Unit name' },
    { id: 'unitDescription', label: 'Unit Description' },
    { id: 'headOfUnit', label: 'Head Of Unit' },
    { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const facilityColumns = [
    { id: 'name', label: 'Name' },
    { id: 'address', label: 'Address' },
    { id: 'phone', label: 'Phone' },
    { id: 'email', label: 'Email' },
    { id: 'actions', label: 'Actions' },
];

export const Ic10Columns = [
    { id: 'code', label: 'Code' },
    { id: 'description', label: 'Description' },
    { id: 'createdDate', label: 'Created At' },
    // { id: 'actions', label: 'Actions' },
];

export const drugsColumns = [
    { id: 'drugName', label: 'Drug Name' },
    { id: 'brandName', label: 'Brand Name' },
    { id: 'createdDate', label: 'Created At' },
    // { id: 'actions', label: 'Actions' },
];

export const labDiagnosticColumns = [
    { id: 'labServiceArea', label: 'Lab Service Area' },
    { id: 'labServiceSubArea', label: 'Lab Service SubArea' },
    { id: 'createdDate', label: 'Created At' },
    // { id: 'actions', label: 'Actions' },
];

export const patientsColumns = [
    { id: 'emrNo', label: 'EMR Number' },
    { id: 'firstName', label: 'First name' },
    { id: 'middleName', label: 'Middle name' },
    { id: 'lastName', label: 'Last name' },
    { id: 'gender', label: 'Gender' },
    { id: 'facilityName', label: 'Facility name' },
    { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const patientVisitColumns = [
    { id: 'patientName', label: 'Patient name' },
    { id: 'facilityName', label: 'Facility name' },
    { id: 'unitName', label: 'Unit name' },
    { id: 'emrno', label: 'EMR No' },
    { id: 'age', label: 'Age' },
    { id: 'slewScore', label: 'Slew Color' },
    { id: 'status', label: 'Status' },
    { id: 'paymentStatus', label: 'Payment status' },
    { id: 'referredToUserId', label: 'Consultation type' },
    { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const ipdAdmissionColumns = [
    { id: 'emrNo', label: 'EMR Number' },
    { id: 'firstName', label: 'First Name' },
    { id: 'middleName', label: 'Middle Name' },
    { id: 'lastName', label: 'Last Name' },
    { id: 'gender', label: 'Gender' },
    { id: 'admissionDate', label: 'Admission Date' },
    { id: 'admissionType', label: 'Admission Type' },
    { id: 'admissionStatus', label: 'Admission Status' },
    { id: 'provisionalDiagnosis', label: 'Provisional Diagnosis' },
    { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const FACILITY_ROLE_ID = '1ab6eb43-3a4f-4091-a008-0be2d445936c';

export const facilityCategories = [
    { label: 'Hospital', value: 'Hospital' },
    { label: 'Clinic', value: 'Clinic' },
    { label: 'Community Health Centre', value: 'Community Health Centre' },
];

export const consultationColumns = [
    { id: 'patientName', label: 'Patient name' },
    { id: 'facilityName', label: 'Facility name' },
    { id: 'labOrderTotalPrice', label: 'Lab order total price' },
    { id: 'followUpDate', label: 'Followup date' },
    { id: 'referredToUserId', label: 'Consultation type' },
    { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const serviceMasterColumns = [
    { id: 'serviceArea', label: 'Service Area' },
    { id: 'serviceSubArea', label: 'Service SubArea' },
    { id: 'createdDate', label: 'Created At' },
    // { id: 'actions', label: 'Actions' },
];

export const labOrdersColumns = [
    { id: 'patientName', label: 'Patient name' },
    { id: 'facilityName', label: 'Facility name' },
    { id: 'consultByName', label: 'Doctor name' },
    { id: 'labServiceArea', label: 'Lab service area' },
    { id: 'labServiceSubArea', label: 'Lab service sub area' },
    { id: 'labOrderType', label: 'Lab order type' },
    { id: 'fees', label: 'Fee' },
    { id: 'paymentStatus', label: 'Payment status' },
    { id: 'paymentType', label: 'Payment type' },
    { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const insuranceColumns = [
    { id: 'patientName', label: 'Patient name' },
    { id: 'facilityName', label: 'Facility name' },
    { id: 'insuranceType', label: 'Insurance type' },
    { id: 'policyNumber', label: 'Policy number' },
    { id: 'providerName', label: 'Provider name' },
    { id: 'coverageAmount', label: 'Coverage amount' },
    { id: 'status', label: 'Status' },
    { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const providerColumns = [
    { id: 'providerName', label: 'Provider Name' },
    // { id: 'address', label: 'Address' },
    { id: 'phoneNo', label: 'Phone Number' },
    // { id: 'email', label: 'Email' },
    { id: 'wellbodiWalletId', label: 'WellBodi Wallet No' },
    // { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const paymentReportsColumns = [
    { id: 'dateTime', label: 'Date and Time' },
    { id: 'patientName', label: 'Patient Name' },
    { id: 'emrNo', label: 'EMR No.' },
    { id: 'billAmount', label: 'Total Bill Amount' },
    { id: 'staffUser', label: 'Staff User' },
];

export const generalCaseLoadColumns = [
    { id: 'doctorName', label: 'Doctor Name' },
    { id: 'phoneNumber', label: 'Phone Number' },
    { id: 'periodCaseLoad', label: 'Period Case Load' },
    { id: 'monthlyChange', label: 'Monthly Change' },
    { id: 'ytdCaseLoad', label: 'YTD Case Load' },
];

export const individualCaseLoadColumns = [
    { id: 'date', label: 'Date' },
    { id: 'patientName', label: 'Patient Name' },
    { id: 'emrNo', label: 'EMR No.' },
    { id: 'timeAssigned', label: 'Time Assigned' },
    { id: 'assignedBy', label: 'Assigned By' },
];

export const patientRegistrationColumns = [
    { id: 'date', label: 'Date' },
    { id: 'count', label: 'Count' },
    { id: 'growthRate', label: 'Growth Rate %' },
];

export const triageAndVitalColumns = [
    { id: 'emrNo', label: 'EMR No' },
    { id: 'firstName', label: 'First Name' },
    { id: 'lastName', label: 'Last Name' },
    { id: 'dob', label: 'DOB' },
    { id: 'gender', label: 'Gender' },
    { id: 'chiefComplaint', label: 'Chief Complaint' },
    { id: 'createdDate', label: 'Created Date' },
];

export const VandTKeys = [
    'createdDate',
    'chiefComplaint',
    'airwayObstruction',
    'patientBreathless',
    'burns',
    'activeSeizures',
    'cardiacArrest',
    'mobility',
    'rr',
    'facialBurns',
    'bloodGlucose',
    'slewScore',
    'oxygen',
    'height',
    'hr',
    'bp',
    'fever',
    'temperature',
    'avpu',
    'trauma',
    'weight',
    'malariaRDT',
    'comment',
];

export const patientKeys = [
    'unitName',
    'consultationByName',
    'facilityName',
    'patientName',
    'serviceFeesTotal',
    'paymentType',
    'paymentStatus',
    'status',
    'vitalTriage',
    'patientVisitServices',
    'patientVisitInfo',
    'patientTriageVitalinfo',
    'createdDate',
];

export const visitKeys = ['serviceArea', 'serviceFees', 'serviceSubArea'];

export const labOrderKeys = [
    'facilityName',
    'consultByName',
    'labOrderType',
    'labServiceArea',
    'labServiceSubArea',
    'patientVisitId',
    'status',
    'consultation',
    'createdDate',
    'updatedDate',
    'paymentType',
];

export const userViewFields = [
    'address',
    'createdDate',
    'eSigned',
    'email',
    'firstName',
    'gender',
    'lastName',
    'mobileCodeId',
    'mobileNumber',
    'roleName',
];

export const patientViewFields = [
    'firstName',
    'middleName',
    'lastName',
    'gender',
    'maritalStatus',
    'dob',
    'pob',
    'category',
    'motherFullName',
    'fatherFullName',
    'fatherOccupation',
    'motherOccupation',
    'patientIdentity',
    'facilityId',
    'facilityName',
    // 'dateOfBirth',
    'age',
    'createdOn',
    'headShotPicture',
    'mobilePhoneNo1',
    'mobilePhoneNo2',
    'emailAddress',
    'socialSecurityNo',
    'nin',
    'emrNo',
    'nationality',
    'residentialAddress',
];

export const labOrderResultKeys = [
    'attachmentPath',
    'createdDate',
    'instruction',
    'labOrderName',
    'labOrderType',
];

export const insuranceKeys = [
    'facilityName',
    'insuranceType',
    'policyNumber',
    'providerName',
    'coverageAmount',
    'status',
    'createdDate',
    'updatedDate',
];

export const providerKeys = [
    'providerName',
    'address',
    'phoneNo',
    'email',
    'wellbodiWalletId',
    'createdDate',
    'updatedDate',
];

export const planColumns = [
    { id: 'planName', label: 'Plan Name' },
    { id: 'benefitLimit', label: 'Benefit Limit' },
    { id: 'benefitAmount', label: 'Benefit Amount' },
    { id: 'inpatientRatio', label: 'Inpatient Ratio' },
    { id: 'actions', label: 'Actions' },
];

export const beneficiaryColumns = [
    { id: 'primaryBeneficiaryName', label: 'Primary Beneficiary Name' },
    { id: 'primaryBeneficiaryEMRNo', label: 'Primary EMR No' },
    { id: 'dependentName', label: 'Dependent Name' },
    { id: 'dependentRelationship', label: 'Relationship' },
    { id: 'dependentEMRNo', label: 'Dependent EMR No' },
    { id: 'insurancePlanName', label: 'Plan Name' },
    { id: 'createdDate', label: 'Created At' },
    { id: 'actions', label: 'Actions' },
];

export const beneficiaryKeys = [
    'primaryBeneficiaryName',
    'primaryBeneficiaryEMRNo',
    'dependentName',
    'dependentRelationship',
    'dependentEMRNo',
    'insurancePlanName',
    'createdDate',
];

export const beneficiaryUsageColumns = [
    { id: 'primaryName', label: 'Primary Name' },
    { id: 'dependentName', label: 'Dependent Name' },
    { id: 'relationship', label: 'Relationship' },
    { id: 'emrNo', label: 'EMR No' },
    { id: 'planName', label: 'Plan Name' },
    { id: 'usedAmount', label: 'Used Amount' },
    { id: 'remainingAmount', label: 'Remaining Amount' },
    { id: 'paymentStatus', label: 'Payment Status' },
    { id: 'facilityName', label: 'Facility Name' },
    { id: 'invoiceNo', label: 'Invoice No' },
    { id: 'createdDate', label: 'Created Date' },
    { id: 'actions', label: 'Actions' },
];

export const beneficiaryUsageKeys = [
    'primaryName',
    'primaryEMR',
    'dependentName',
    'dependentEMR',
    'relationship',
    'emrNo',
    'planName',
    'benefitLimit',
    'benefitAmount',
    'usedAmount',
    'totalBenefitAmount',
    'remainingAmount',
    'paymentType',
    'paymentStatus',
    'facilityName',
    'invoiceNo',
    'visitId',
    'createdDate',
];

export const planKeys = [
    'planName',
    'insuranceProviderId',
    'benefitLimit',
    'benefitAmount',
    'benefitSplit',
    'outpatientRatio',
    'inpatientRatio',
    'dependentsLimit',
    'createdDate',
    'updatedDate',
];

export const facilityKeys = [
    'name',
    'address',
    'district',
    'phone',
    'email',
    'category',
    'noOfStaff_Male',
    'noOfStaff_Female',
    'createdDate',
    'status',
    'isLab',
];

export const genderOptions = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Unknown', label: 'Unknown' },
];

export const confirmOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
];

export const maritalStatusOptions = [
    { value: 'Single', label: 'Single' },
    { value: 'Married', label: 'Married' },
    { value: 'Divorced', label: 'Divorced' },
    { value: 'Widowed', label: 'Widowed' },
];

/** Map legacy stored/API value so edit forms match current radio options */
export const normalizeMaritalStatusForForm = (
    value: string | undefined | null,
): string => {
    if (value == null || value === '') {
        return '';
    }
    const v = String(value).trim();
    if (v === 'Unmarried' || v === 'unmarried') {
        return 'Single';
    }
    return v;
};

export const reportTypes = [
    { label: 'Payment Report', value: 'Payment Report' },
    { label: 'General Case Load', value: 'General Case Load' },
    { label: 'Individual Case Load', value: 'Individual Case Load' },
    { label: 'Patient Registration', value: 'Patient Registration' },
    { label: 'Triage and Vital', value: 'Triage and Vital' },
];

export const paymentOptions = [
    { value: 'Cash', label: 'Cash' },
    { value: 'Gratis', label: 'Gratis' },
    { value: 'FHC Account', label: 'FHC Account' },
    { value: 'Insurance', label: 'Insurance' },
    { value: 'Follow-Up', label: 'Follow-Up' },
];

/** Lab Orders (Lab User) payment types. Stored values match PatientVisit.PaymentType. */
export const labPaymentOptions = [
    { value: 'Cash', label: 'Cash' },
    { value: 'Gratis', label: 'Gratis' },
    { value: 'Follow-Up', label: 'Follow-up' },
    { value: 'Insurance', label: 'Insurance' },
];
export const mobilityOptions = [
    { label: 'Walking', value: 'Walking' },
    { label: 'Rest', value: 'Rest' },
    { label: 'Wheel chair', value: 'Wheel chair' },
    { label: 'Stretcher', value: 'Stretcher' },
];

export const avpuOptions = [
    { label: 'Alert', value: 'Alert' },
    { label: 'Not Alert', value: 'Not Alert' },
];

export const malariaRDTOptions = [
    { label: 'Reactive', value: 'Reactive' },
    { label: 'Non Reactive', value: 'Non Reactive' },
];

export const referralOptions = [
    {
        label: 'Internal Referral',
        value: 'Internal Referral',
    },
    {
        label: 'External Referral',
        value: 'External Referral',
    },
];

export const drugFormOptions = [
    {
        label: 'Tabs',
        value: 'Tabs',
    },
    {
        label: 'Syrup',
        value: 'Syrup',
    },
    {
        label: 'Caps',
        value: 'Caps',
    },
    {
        label: 'Injections',
        value: 'Injections',
    },
];

export const slewColorOptions = [
    {
        label: 'Green',
        value: 'Green',
    },
    {
        label: 'Red',
        value: 'Red',
    },
    {
        label: 'Orange',
        value: 'Orange',
    },
    {
        label: 'Yellow',
        value: 'Yellow',
    },
];
